
define('ldsh!modules/start/products/email/activity/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isAdm) { ;
__p += '\n<div class="col-xs-8 col-sm-10 col-md-4 col-lg-4">\n';
 } else { ;
__p += '\n<div class="col-xs-8 col-sm-10 col-md-10 col-lg-10">\n';
 } ;
__p += '\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <h3 class="i18n" style="margin-top: 5px;" data-i18n="PUBLIC.PRODUCTS.MDIRECTOR.PRODUCT_NAME"></h3>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-12 col-lg-12" style="min-height: 27px;">\n            <p><b class="i18n" data-i18n="PUBLIC.PRODUCTS.DELIVERIES_NUMBER"></b> <span class="product-number">' +
__e(formatNumber(deliveries)) +
'</span></p>\n        </div>\n    </div>\n\n    <div class="row product-activity-table">\n        <div class="col-xs-12 product-activity-row">\n            <table>\n                <tr>\n                    <td class="product-border-right">\n                        <span class="product-number">' +
__e(formatNumber(opening_percent)) +
'</span><span class="i18n" style="font-size: 11px;" data-i18n="PUBLIC.PRODUCTS.LOWBAR.OPENINGS_%">% Aperturas</span>\n                    </td>\n                    <td class="product-border-right">\n                        <span class="product-number">' +
__e(formatNumber(clicks)) +
'</span><span class="i18n" style="font-size: 11px;" data-i18n="PUBLIC.PRODUCTS.LOWBAR.CLICKS"> Clics</span>\n                    </td>\n                    <td>\n                        <span class="product-number">' +
__e(formatNumber(ctr)) +
'</span><span class="i18n" style="font-size: 11px;" data-i18n="PUBLIC.PRODUCTS.LOWBAR.CTR">% CTR</span>\n                    </td>\n                </tr>\n            </table>\n        </div>\n\n    </div>\n\n</div>\n\n\n';

}
return __p
};});

